<template src="./review-responses.html"></template>

<script lang="ts">
import ReviewByline from 'objects/byline/ReviewByline.vue'

export default {
  props: {
    /* Example structure with 1 source. If source was a brand, 'isStaff' would be false,
       and 'expertLabel' would be populated.
      [{
        "source": "Nike",
        "responses": [
          {
              "id": 111,
              "text": "We're sorry that you had this experience.",
              "dateCreatedFormatted": "2016-09-03",
              "isStaff": true,
              "user": {
                  "firstName": "Clarice",
                  "lastName": "Starling"
              }
          },
          {
              "id": 112,
              "text": "PS, the new model will be out next month.",
              "dateCreatedFormatted": "2016-09-04",
              "isStaff": true,
              "user": {
                  "firstName": "Clarice",
                  "lastName": "Starling"
              }
          }
        ]
      }]
    */
    responsesBySource: { type: Array }
  },
  components: {
    'tt-review-byline': ReviewByline
  }
}
</script>

<style lang="scss" src="./review-responses.scss"></style>
